<main class="container-fluid">
    <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
      <section class="col-12 p-4 mb-5">
  
        <div class="d-flex justify-content-between">
          <div>
            <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
            <label class="h5">Reporte de certificados</label>
          </div>
          <p>
            <button type="button" class="btn btn-outline-success mr-3" (click)="isExportar = !isExportar"
              [attr.aria-expanded]="!isExportar">Exportar</button>
            <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
              [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
              Ver filtros
            </button>
          </p>
        </div>
  
        <div id="exportar-form" *ngIf="!isExportar">
          <div class="card mb-3">
            <div class="card-body">
              <form [formGroup]="exportarForm" (submit)="submit()">
                <div class="row">
                  <div class="col-3 mb-2 input-group-prepend" formArrayName="exportarList"
                    *ngFor="let order of exportarForm.controls.exportarList.controls; let i = index">
                    <div class="input-group-text">
                      <input type="checkbox" [formControlName]="i">
                    </div>
                    <label class="label label-primary medium" for="">{{exportarList[i].name}}</label>
                  </div>
                  <div class="col-4 mb-2 input-group-prepend">
                    <div class="input-group-text">
                      <input type="checkbox" formControlName="selectAll">
                    </div>
                    <label class="label label-primary medium" for="">Seleccionar/Deseleccionar Todo</label>
                  </div>
                  <div class="col-2"></div>
                  <div class="col-2">
                    <button class="btn btn-success m-auto" type="submit"
                      [disabled]="!exportarForm.valid">Exportar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
  
  
        <div id="filtros" [ngbCollapse]="isCollapsed">
          <div class="card mb-3">
            <div class="card-body">
              <form [formGroup]="filtro" (submit)="filtrar()">
                <div class="row">
                  <div class="col-2 form-group" >
                    <label class="small text-secondary" for="codigo_camara">Cámara de Comercio</label>
                    <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                      <option class="" value="" selected="true">
                        Seleccione
                      </option>
                      <option class="" *ngFor="let option of camarasLista; let i = index"
                        value="{{option?.codigo_camara}}" [selected]="false">
                        {{option?.desc_camara}}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary" for="numero_identificacion">NIT del propietario</label>
                    <input id="numero_identificacion" formControlName="numero_identificacion" type="text" class="form-control form-control-sm">
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary" for="tipo_rnt">Tipo RNT</label>
                    <select class="form-control form-control-sm" id="tipo_rnt" formControlName="tipo_rnt">
                      <option class="" value="" selected="true">
                        Seleccione
                      </option>
                      <option class="" *ngFor="let option of tipoRNT; let i = index" value="{{option?.tipo_rnt_id}}"
                        [selected]="false">
                        <!-- Traer las opciones de tipo RNT -->
                        {{option?.descripcion}}
                        <!-- Acá se recorre las opciones de tipo RNT -->
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary" for="codigo_departamento">Departamento</label>
                    <select class="form-control form-control-sm" id="codigo_departamento" formControlName="codigo_departamento" (change)="onMunicipioSelect()">
                       <option class="" value="" selected="true">
                           Seleccione
                        </option>
                       <option class="" *ngFor="let option of departamento; let i = index"
                           value="{{option?.departamento_id}}" [selected]="false">
                           {{option?.descripcion}}
                       </option>
                    </select>
                  </div>
                 <div class="col-2 form-group">
                     <label class="small text-secondary" for="codigo_municipio">Municipio</label>
                     <select class="form-control form-control-sm" id="codigo_municipio" formControlName="codigo_municipio">
                        <option class="" value="" selected="true">
                            Seleccione
                         </option>
                        <option class="" *ngFor="let option of municipio; let i = index"
                            value="{{option?.municipio_id}}" [selected]="false">
                            {{option?.descripcion}}
                        </option>
                     </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary" for="estado_rnt_id">Estado RNT</label>
                    <select class="form-control form-control-sm" id="estado_rnt_id" formControlName="estado_rnt">
                      <option class="" value="" selected="true">
                        Seleccione
                      </option>
                      <option class="" *ngFor="let option of estadoRnt; let i = index" value="{{option?.estado_rnt_id}}"
                        [selected]="false">
                        {{option?.descripcion}}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary" for="codigo_categoria">Categoría</label>
                    <select class="form-control form-control-sm" id="codigo_categoria" formControlName="codigo_categoria">
                      <option class="" value="" selected="true">
                        Seleccione
                      </option>
                      <option class="" *ngFor="let option of categoria; let i = index" value="{{option?.categoria_id}}"
                        [selected]="false">
                        {{option?.descripcion}}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary" for="codigo_rnt">Código RNT</label>
                    <input id="codigo_rnt" formControlName="codigo_rnt" type="text"
                      class="form-control form-control-sm">
                  </div>
                  <div class="col-2 form-group">
                    <label class="text-secondary small">Fecha Expedición Desde</label>
                    <div class="input-group">
                      <input class="form-control form-control-sm" formControlName="fecha_expedicion_desde"
                        placeholder="yyyy/mm/dd" ngbDatepicker #inicio_expedicion="ngbDatepicker" (dateSelect)="onCheckDateInicio($event)">
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="inicio_expedicion.toggle()"
                          type="button"></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-2 form-group">
                    <label class="text-secondary small">Fecha Expedición Hasta</label>
                    <div class="input-group">
                      <input class="form-control form-control-sm" formControlName="fecha_expedicion_hasta"
                        placeholder="yyyy/mm/dd" ngbDatepicker #fin_expedicion="ngbDatepicker"  [minDate]="fecha_inicio_expedicion" (dateSelect)="onCheckDateInicio($event)">
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="fin_expedicion.toggle()"
                          type="button"></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-2 form-group">
                    <label class="text-secondary small">Fecha Vencimiento Desde</label>
                    <div class="input-group">
                      <input class="form-control form-control-sm" formControlName="fecha_vencimiento_desde" (dateSelect)="onCheckDateVencimiento($event)"
                        placeholder="yyyy/mm/dd" ngbDatepicker #inicio_vencimiento="ngbDatepicker" >
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="inicio_vencimiento.toggle()" type="button"></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-2 form-group">
                    <label class="text-secondary small">Fecha Vencimiento Hasta</label>
                    <div class="input-group">
                      <input class="form-control form-control-sm" formControlName="fecha_vencimiento_hasta" (dateSelect)="onCheckDateVencimiento($event)"
                        placeholder="yyyy/mm/dd" ngbDatepicker #fin_vencimiento="ngbDatepicker" [minDate]="fecha_inicio_vencimiento" >
                      <div class="input-group-append">
                        <button class="btn btn-outline-secondary calendar" (click)="fin_vencimiento.toggle()" type="button"></button>
                      </div>
                    </div>
                  </div>
  
                  <div class="col-2 form-group">
                    <label class="small text-secondary" for="codigo_certificado_unico">Código de certificado único</label>
                    <input id="codigo_certificado_unico" formControlName="codigo_certificado_unico" type="text"
                      class="form-control form-control-sm">
                  </div>
                  <div class="d-flex flex-row">
                    <button type="reset" class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                      (click)="limpiar()">Limpiar</button>
                    <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical"
                      type="submit">Filtrar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
  
        <div class="table-responsive">
          <app-tablas [page]="paginaActual" [headers]="headerTabla" [sizeData]="dataTabla.paging.totalItems"
            (paginado)="onPaginado($event)" class="table-responsive">
            <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
              <td>{{item.camara}}</td>
              <td>{{item.departamento}}</td>
              <td>{{item.municipio}}</td>
              <td>{{item.razon_social_establecimiento}}</td>
              <td>{{item.numero_identificacion}}</td>
              <td>{{item.razon_social_prestador}}</td>
              <td>{{item.codigo_certificado_unico}}</td>
              <td>{{item.codigo_rnt}}</td>
              <td>{{item.tipo_rnt}}</td>
              <td>{{item.categoria}}</td>
              <td>{{item.subcategoria}}</td>
              <td>{{item.estado_rnt}}</td>
              <td>{{item.fecha_inscripcion}}</td>
              <td>{{item.fecha_vencimiento}}</td>
              <td>{{item.usuario_creacion}}</td>
              <td>{{item.rol}}</td>
              <td>{{item.ruta_url}}</td>
              <td *ngIf="authService.getRolUser(adminSuper)">
                <ng-template #popContent>
                  <ng-container *ngFor="let accionRnt of accionesRnt">
                    <button
                      class="btn btn-outline-light border-0 text-left w-100"
                      (click)="onAcciones(item, accionRnt)"
                    >
                      {{ accionRnt.accion }}
                    </button>
                  </ng-container>
                </ng-template>
                <button
                  type="button"
                  class="btn btn-outline-secondary text-center"
                  placement="bottom"
                  [ngbPopover]="popContent"
                  (shown)="onLoadAcciones(item)"
                  (hidden)="onDismissAcciones()"
                  popoverClass="bg-dark"
                >
                  ..
                </button>
              </td>
            </tr>
          </app-tablas>
        </div>
      </section>
    </article>
  </main>
  